
import {Component, Mixins, Prop, Vue, Watch} from "vue-property-decorator";
import YargiTuruPicker from "@/components/pickers/YargiTuruPicker.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {TaskDurum} from "@/plugins/uyap-plugin/enum/TaskDurum";
import ListelemeTuruPicker from "@/components/pickers/ListelemeTuruPicker.vue";
import Dates from "@/components/inputs/Dates.vue";
import * as XLSX from 'xlsx';
import {ProgramPaths} from "@/enum/ProgramPaths";
import {IcraDairesiEntity} from "@/entity/IcraDairesiEntity";
import {AvukatIcraDosyalariTalep} from "@/plugins/uyap-plugin/uyap/AvukatIcraDosyalari";
import {IAvukatDosya, MahkemeBirimleriRow} from "@/plugins/uyap-plugin/uyap/CommonInterfaces";
import {birimBul, excelSatirlariniCozumle, excelDogrula} from "@/components/eicrapro/senkron/excelDosyaCozumleme";
import DosyaFiltrelemeCard, {ListelemeTuru} from "@/components/eicrapro/DosyaFiltrelemeCard.vue";
import ExcelYuklemeCard from "@/components/eicrapro/ExcelYuklemeCard.vue";
import TakipTabloFiltre from "@/components/eicrapro/TakipTabloFiltre.vue";
import {
  GorunurTakipSonucu,
  hesaplaGorunurTakipler,
  kesistir,
  secimdenCikar,
  secimeEkle,
  TakipTabloFiltreEntity
} from "@/components/forms/form-wizard/eicrapro/genelIslemTakipFiltre";

@Component({
  computed: {
    ListelemeTuru() {
      return ListelemeTuru
    }
  },
  components: {TakipTabloFiltre, ExcelYuklemeCard, DosyaFiltrelemeCard, Dates, ListelemeTuruPicker, YargiTuruPicker}
})

export default class GenelIslemFormWizard extends Mixins(ObjectInputMixin) {
  @Prop({default: ["Listelenecek Takipler", "Takipleri Seç", "İşlemler", "İşlemler Sıraya Alındı"]}) stepperHeaders!: Array<string>;
  @Prop() showSuccessCloseButton!: string | boolean;
  @Prop() hideNextButton!: string | boolean;
  @Prop({default: false}) onFly!: boolean;
  @Prop({default: 'Yeni işlem için'}) successMessage!: string;
  @Prop({default: false}) showSecilenTakiplerExcelExport!: boolean;

  activeStep: number = 1;
  takipSecilmediError = false;
  secilenlerDialog = false;
  localValue: GenelIslemEntity = new GenelIslemEntity();
  taskDurum = TaskDurum;
  uyapTakipLoadStatus = {
    loading: false,
    error: false,
    errorMessage: ''
  };
  icraDaireleri: Array<MahkemeBirimleriRow> = [];

  headers = [
    {text: "Birim Adı", value: "birimAdi"},
    {text: "Dosya Esas No", value: "dosyaNo"},
    {text: "Açılış Tarihi", value: "dosyaAcilisTarihi"},
    {text: "Dosya Durumu", value: "dosyaDurum"}
  ];

  // Eşleşen UYAP dairesi, kullanıcının yazdığından farklıysa parantez içinde gösterilir.
  // Birebir aynıysa tekrar yazmak gürültü olurdu; Excel yüklemesi zaten eşleşmeyen satır
  // varsa hiç kabul edilmediği için parantezin yokluğu "yazdığınız ad UYAP'takiyle aynı"
  // demektir.
  eslesenBirimAdiFarkliMi(item: any): boolean {
    if (!item || !item.eslesenBirimAdi)
      return false;
    return this.birimAdiNormalize(item.eslesenBirimAdi) !== this.birimAdiNormalize(item.birimAdi);
  }

  get isShowSuccessCloseButton() {
    return this.showSuccessCloseButton || this.showSuccessCloseButton === "";
  }

  get isHideNextButton() {
    return this.hideNextButton || this.hideNextButton === "";
  }

  get takipSorguTakipSecCardBind(): Record<string, unknown> {
    if (!this.showSecilenTakiplerExcelExport) {
      return {};
    }
    return {
      outlined: true,
      class: {
        'takip-sorgu-data-card': true,
        'takip-sorgu-data-card--error': this.takipSecilmediError
      }
    };
  }

  get takipSorguTakipSecTableStyle(): string | undefined {
    if (this.showSecilenTakiplerExcelExport) {
      return undefined;
    }
    return this.takipSecilmediError
        ? 'border: #ff5252 solid 1px; padding:20px'
        : 'border: #e0e0e0 solid 1px; padding:20px';
  }

  get takipSorguSecilenListeCardBind(): Record<string, unknown> {
    if (!this.showSecilenTakiplerExcelExport) {
      return {};
    }
    return {
      outlined: true,
      class: 'takip-sorgu-data-card mt-4'
    };
  }

  get takipSorguSecilenListeTableStyle(): string | undefined {
    if (this.showSecilenTakiplerExcelExport) {
      return undefined;
    }
    return 'border: #e0e0e0 solid 1px; padding:20px';
  }

  /**
   * Ekranda gorunen satir kumesinin TEK KAYNAGI. Tablo, "tumunu sec", sayaclar, Excel indirme
   * ve gorev olusturma hepsi buradan besleniyor; eskiden tablo kendi filtrelerinden,
   * Vuetify'in :search prop'u ise ayri bir katmandan geciyordu ve ikisi ayrisiyordu. (DEV-2718)
   */
  get gorunurTakipSonucu(): GorunurTakipSonucu {
    return hesaplaGorunurTakipler(this.localValue.takipler, this.localValue.tabloFiltre);
  }

  get gorunurTakipler(): Array<any> {
    return this.gorunurTakipSonucu.satirlar;
  }

  /** Secili satirlarin kac tanesi su anki filtrede goruluyor. */
  get gorunurSeciliSayisi(): number {
    return kesistir(this.localValue.secilen_takipler, this.gorunurTakipler).length;
  }

  /**
   * Secili olup su anki filtrede GORUNMEYEN satir sayisi. Secim filtreler arasinda birikiyor
   * (kullanici bir filtreyle 3, digeriyle 2 dosya secebiliyor); bu sayi sifirdan buyukse
   * kullanici uyarilir ve "Secilenleri goster" ile listeye ulasip tek tek kaldirabilir.
   * Tehlikeli olan biriktirme degil, gorunmeyen secimdi. (DEV-2720)
   */
  get gizliSeciliSayisi(): number {
    return this.localValue.secilen_takipler.length - this.gorunurSeciliSayisi;
  }

  /** Baslik kutusu GORUNUR satirlari temsil eder, secimin tamamini degil. */
  get tumuSecildiMi(): boolean {
    return this.gorunurTakipler.length > 0
        && this.gorunurSeciliSayisi === this.gorunurTakipler.length;
  }

  get secilenlerHeaders() {
    return this.headers.concat([{text: '', value: 'secimKaldir'}]);
  }

  @Watch('localValue.secilen_takipler')
  onSecilenTakiplerChange() {
    this.takipSecilmediError = false;
  }

  secimdenCikart(takip: any) {
    this.localValue.secilen_takipler = secimdenCikar(this.localValue.secilen_takipler, [takip]);
    this.input();
  }

  tumSecimiKaldir() {
    this.localValue.secilen_takipler = [];
    this.secilenlerDialog = false;
    this.input();
  }

  // mounted olması lazım nedeni araştıralacak
  async created() {
    await this.getIcraDaireleri();
  }

  async getIcraDaireleri() {
    try {
      const response = await this.$uyap.MahkemeBirimleri().run({
        yargiTuru: this.localValue.filtre.yargiTuru,
        yargiBirimi: this.localValue.filtre.yargiBirimi,
        dosyaKapaliMi: (this.localValue.filtre.dosyaKapaliMi == 0) ? false : true
      })
      this.icraDaireleri = response.items;
    } catch (error) {
      console.error('İcra daireleri yüklenirken hata oluştu:', error);
    }
  }

  async getTakipler() {
    // Suren bir listeleme varken ikinci istek acilirsa gec donen eski yanit yenisinin uzerine
    // yaziyor; ekranda A sorgusunun satirlari gorunurken secim B sorgusundan kalabiliyor.
    if (this.uyapTakipLoadStatus.loading)
      return;
    this.localValue.takipler = [];
    this.$nextTick(async () => {
      try {
        this.uyapTakipLoadStatus.loading = true;
        // Onceki denemeden kalan hata, yeni listeleme basarili olsa bile Devam'i kilitliyor.
        this.uyapTakipLoadStatus.error = false;
        this.uyapTakipLoadStatus.errorMessage = '';
        this.localValue.secilen_takipler = [];
        // Yeni liste, yeni tablo filtresi. Onceki listeden kalan filtre yeni listeyi sessizce
        // bosaltabiliyordu (ozellikle Excel'e gecildiginde). (DEV-2723)
        this.localValue.tabloFiltre = new TakipTabloFiltreEntity();

        if (this.localValue.excel)
          await this.handleExcelUpload();
        else
          await this.handleUyapQuery();
      } catch (error) {
        this.handleGetTakiplerError(error);
      } finally {
        this.uyapTakipLoadStatus.loading = false;
      }
    });
  }

  async handleExcelUpload() {
    const excelFile = this.localValue.excel;
    // birimAdi doğrulaması icra daireleri listesine dayanıyor; listenin hazır olduğundan emin ol.
    if (this.icraDaireleri.length === 0)
      await this.getIcraDaireleri();

    const data = await this.readExcelFile(excelFile);
    const excelData = this.parseExcelFile(data);
    this.validateExcelData(excelData);
    this.localValue.takipler = excelData;
  }

  // FileReader'ı promise'e sar: aksi halde handleExcelUpload dosya okunmadan döner ve
  // "yükleniyor" göstergesi kapanıp kullanıcı yarım listeyle devam edebiliyor.
  readExcelFile(excelFile: File): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e: any) => resolve(e.target.result);
      reader.onerror = () => reject(new Error("Excel dosyası okunamadı."));
      reader.readAsBinaryString(excelFile);
    });
  }

  // Excel dosyasını parse et. Satır çözümleme kuralları senkron plan ekranıyla
  // ORTAK modülden gelir (excelDosyaCozumleme.excelSatirlariniCozumle): iki ekran
  // aynı Excel dosyasını kabul etmeli, biri kabul edip diğeri reddederse kullanıcı
  // hangi ekranda ne olduğunu anlayamaz.
  parseExcelFile(data: any): any[] {
    const workbook = XLSX.read(data, {type: 'binary'});
    const first_sheet_name = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[first_sheet_name];
    const hamSatirlar: any[] = XLSX.utils.sheet_to_json(worksheet, {raw: true, blankrows: false});

    return excelSatirlariniCozumle(hamSatirlar, this.icraDaireleri, {
      normalize: (ad: any) => this.birimAdiNormalize(ad),
      kanonik: (ad: any) => this.birimAdiKanonik(ad)
    });
  }

  // Excel verilerini doğrula. Hata mesajları da aynı ortak modülden (excelDogrula)
  // gelir; aksi halde bu ekranla senkron plan ekranı aynı senaryoda farklı cümle
  // gösterir.
  validateExcelData(excelData: any[]) {
    const hatalar = excelDogrula(excelData, this.icraDaireleri.length);
    if (hatalar.length > 0) {
      throw new Error(hatalar.join(" "));
    }
  }

  // Ad normalizasyonu ve kanonik form TEK KAYNAKTAN gelir: $uyapHelper. DosyaBul görev
  // çalışırken aynı fonksiyonları kullanıyor; kurallar ayrışırsa burada kabul edilen satır
  // görev çalışırken eşleşmez hale gelir.
  birimAdiNormalize(birimAdi: any): string {
    return this.$uyapHelper.birimAdiNormalize(birimAdi);
  }

  birimAdiKanonik(birimAdi: any): string {
    return this.$uyapHelper.birimAdiKanonik(birimAdi);
  }

  // UYAP sorgusu - tüm UYAP mantığı burada
  async handleUyapQuery() {
    const talep = this.buildUyapRequest();
    const takipler = await this.executeUyapQuery(talep);
    this.processTakipler(takipler);
  }

  // UYAP talep objesi oluştur
  buildUyapRequest(): AvukatIcraDosyalariTalep {
    const talep = new AvukatIcraDosyalariTalep();
    talep.dosyaDurumKod = this.localValue.filtre.dosyaKapaliMi;

    // Listeleme türüne göre talep parametrelerini ayarla
    this.applyListelemeTuruToRequest(talep);

    // Detaylı aramadan tarih aralığı varsa ekle
    this.applyDetailedSearchDates(talep);

    return talep;
  }

  // Listeleme türüne göre talep parametrelerini ayarla
  applyListelemeTuruToRequest(talep: AvukatIcraDosyalariTalep) {
    const listeleme_turu = this.localValue.filtre.listeleme_turu;

    if (listeleme_turu === ListelemeTuru.KISI_ILE_ARAMA) {
      talep.setKisi(
          this.localValue.filtre.adi,
          this.localValue.filtre.soyadi,
          this.localValue.filtre.tcKimlikNo
      );
    } else if (listeleme_turu === ListelemeTuru.KURUM_ILE_ARAMA) {
      talep.setKurum(
          this.localValue.filtre.kurumAdi,
          this.localValue.filtre.mersisNo,
          this.localValue.filtre.vergiNo
      );
    } else if (listeleme_turu === ListelemeTuru.ACILIS_TARIH_ARALIGI) {
      talep.setAcilisTarihAraligi(
          this.localValue.filtre.baslangicTarihi,
          this.localValue.filtre.bitisTarihi
      );
    } else if (listeleme_turu === ListelemeTuru.KAPANIS_TARIH_ARALIGI) {
      talep.setKapanisTarihAraligi(
          this.localValue.filtre.baslangicTarihi,
          this.localValue.filtre.bitisTarihi
      );
    } else if (listeleme_turu === ListelemeTuru.SON_1_GUN) {
      this.setDateRangeForLastDays(talep, 1);
    } else if (listeleme_turu === ListelemeTuru.SON_1_HAFTA) {
      this.setDateRangeForLastDays(talep, 7);
    } else if (listeleme_turu === ListelemeTuru.SON_2_HAFTA) {
      this.setDateRangeForLastDays(talep, 14);
    } else if (listeleme_turu === ListelemeTuru.SON_1_AY) {
      this.setDateRangeForLastMonths(talep, 1);
    }
  }

  // Son X gün için tarih aralığı ayarla
  setDateRangeForLastDays(talep: AvukatIcraDosyalariTalep, days: number) {
    const baslangicTarihi = new Date();
    baslangicTarihi.setDate(baslangicTarihi.getDate() - days);
    talep.setAcilisTarihAraligi(baslangicTarihi.toISOString(), new Date().toISOString());
  }

  // Son X ay için tarih aralığı ayarla
  setDateRangeForLastMonths(talep: AvukatIcraDosyalariTalep, months: number) {
    const baslangicTarihi = new Date();
    baslangicTarihi.setMonth(baslangicTarihi.getMonth() - months);
    talep.setAcilisTarihAraligi(baslangicTarihi.toISOString(), new Date().toISOString());
  }

  // Detaylı aramadan tarih aralığı varsa ekle
  applyDetailedSearchDates(talep: AvukatIcraDosyalariTalep) {
    const hasDateRange = this.localValue.filtre.baslangicTarihi || this.localValue.filtre.bitisTarihi;
    const isDateBasedSearch = [
      ListelemeTuru.ACILIS_TARIH_ARALIGI,
      ListelemeTuru.KAPANIS_TARIH_ARALIGI,
      ListelemeTuru.SON_1_GUN,
      ListelemeTuru.SON_1_HAFTA,
      ListelemeTuru.SON_2_HAFTA,
      ListelemeTuru.SON_1_AY
    ].includes(this.localValue.filtre.listeleme_turu);

    if (hasDateRange && !isDateBasedSearch) {
      talep.setAcilisTarihAraligi(
          this.localValue.filtre.baslangicTarihi,
          this.localValue.filtre.bitisTarihi
      );
    }
  }

  // UYAP sorgusunu çalıştır
  async executeUyapQuery(talep: AvukatIcraDosyalariTalep): Promise<any> {
    const listeleme_turu = this.localValue.filtre.listeleme_turu;

    if (listeleme_turu === ListelemeTuru.ESAS_NO_ARALIGI) {
      return await this.queryByEsasNoAraligi(talep);
    } else if (listeleme_turu === ListelemeTuru.ICRAPRO_DOSYALARI) {
      return await this.queryFromIcraProAPI();
    } else {
      return await this.$uyap.AvukatIcraDosyalari().recursive(talep);
    }
  }

  // Esas no aralığı ile sorgula
  async queryByEsasNoAraligi(talep: AvukatIcraDosyalariTalep): Promise<any> {
    const dosyaYil = this.localValue.filtre.dosyaYil || 0;
    const dosyaSira = Number(this.localValue.filtre.dosyaSira) || 0;
    const dosyaSira2 = this.localValue.filtre.dosyaSira2 ? Number(this.localValue.filtre.dosyaSira2) : null;

    // Min/Max kontrolü - UYAP'a doğru sırayla gönder
    let minSira = dosyaSira;
    let maxSira = dosyaSira2;

    if (dosyaSira2) {
      minSira = Math.min(dosyaSira, dosyaSira2);
      maxSira = Math.max(dosyaSira, dosyaSira2);
    }

    return await this.$uyap.AvukatIcraDosyalari().esasNoAraligi(talep, dosyaYil, minSira, maxSira);
  }

  // İcraPRO API'den sorgula
  async queryFromIcraProAPI(): Promise<any> {
    const takiplerRes = await this.$http.get('/api/v1/uyap-dosya-listele');
    const takipler = {items: []};

    takiplerRes.data.forEach((takip: {
      id: number,
      icra_dairesi_id: number,
      dosya_esas_no: string,
      uyap_dosya_id: string,
      icra_dairesi: IcraDairesiEntity
    }) => {
      takipler.items.push({
        birimAdi: takip.icra_dairesi?.isim,
        dosyaNo: takip.dosya_esas_no,
        dosyaId: takip.uyap_dosya_id,
        birimId: takip.icra_dairesi_id.toString()
      });
    });

    return takipler;
  }

  // Takipleri işle ve kaydet
  processTakipler(takipler: any) {
    if (takipler && Array.isArray(takipler.items)) {
      // Takiplere index ekle ve birimId kontrolü yap
      takipler.items.forEach((takip: any, index: number) => {
        takip.index = index;

        // birimId ve birimAdi arasında ilişki kur
        if (!takip.birimId && takip.birimAdi) {
          takip.birimId = this.getBirimIdFromAdi(takip.birimAdi);
        }
      });
      this.localValue.takipler = takipler.items;
    } else {
      console.error("Takipler alınamadı veya geçersiz formatta:", takipler);
      this.uyapTakipLoadStatus.error = true;
      this.uyapTakipLoadStatus.errorMessage = "Takipler alınamadı veya boş döndü";
      this.localValue.takipler = [];
    }
  }

  // Hata yönetimi
  handleGetTakiplerError(error: any) {
    const err = error as any;
    this.uyapTakipLoadStatus.errorMessage = err.message;
    this.uyapTakipLoadStatus.error = true;
    console.error("Takipler alınırken hata:", err.message);
  }

  // Verilen ada karşılık gelen UYAP icra dairesini bulur. Tam ad tutmazsa kanonik ad ile
  // denenir: yerel kayıtlarda daire adı UYAP yazımından farklı olabiliyor
  // ("Ankara 1. İcra Dairesi" ↔ "Ankara 1. Genel İcra Dairesi"). Kanonik ad birden fazla
  // daireye uyuyorsa hangisi olduğu bilinemez; null dönüp satırı reddediyoruz.
  //
  // Arama mantığı ve O(1) indeksleme `excelDosyaCozumleme.birimBul`de TEK KAYNAKTAN
  // gelir (DEV-2603 B05): Excel yolu ile bu ekran aynı büyük daire listesini satır
  // satır tarıyordu, indeks `this.icraDaireleri` referansına göre orada önbelleklenir.
  bulIcraDairesi(birimAdi: string): MahkemeBirimleriRow | null {
    return birimBul(this.icraDaireleri, birimAdi, {
      normalize: (ad: any) => this.birimAdiNormalize(ad),
      kanonik: (ad: any) => this.birimAdiKanonik(ad)
    });
  }

  getBirimIdFromAdi(birimAdi: string): string {
    const daire = this.bulIcraDairesi(birimAdi);
    return daire ? daire.birimId.toString() : "";
  }


  private takiplerdenExcelSatirlari(items: IAvukatDosya[]): Array<Record<string, string>> {
    return items.map((item: IAvukatDosya) => ({
      'Birim Adı': item.birimAdi ?? '',
      'Dosya Esas No': item.dosyaNo ?? '',
      'Açılış Tarihi': item.dosyaAcilisTarihi
          ? this.$uyapHelper.tarihLocaleStr(item.dosyaAcilisTarihi)
          : '',
      'Dosya Durumu': item.dosyaDurum ?? ''
    }));
  }

  private takipleriXlsxYaz(
      items: IAvukatDosya[],
      sheetAdi: string,
      dosyaAdi: string
  ): void {
    if (items.length === 0) {
      return;
    }
    const worksheet = XLSX.utils.json_to_sheet(this.takiplerdenExcelSatirlari(items));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetAdi);
    XLSX.writeFile(workbook, dosyaAdi);
  }

  indirTabloTakipleriExcel(): void {
    const tarih = new Date().toISOString().slice(0, 10);
    this.takipleriXlsxYaz(
        this.gorunurTakipler as IAvukatDosya[],
        'Takipler',
        `takipler-listesi_${tarih}.xlsx`
    );
  }

  indirSecilenTakiplerExcel(): void {
    const tarih = new Date().toISOString().slice(0, 10);
    this.takipleriXlsxYaz(
        this.localValue.secilen_takipler,
        'SecilenTakipler',
        `secilen-takipler_${tarih}.xlsx`
    );
  }

  /**
   * Gorunur kumenin TAMAMINI secer/birakir -- yalnizca goruntulenen sayfayi degil. Kume artik
   * arama metnini de iceriyor; eskiden arama kutusuna yazip 1 satir gorurken dugmeye basmak
   * arama oncesi tum listeyi seciyordu. (DEV-2719)
   *
   * Baska bir filtrede secilmis satirlara DOKUNMAZ: yalnizca gorunur olanlari ekler/cikarir.
   */
  selectAll() {
    if (this.tumuSecildiMi)
      this.localValue.secilen_takipler = secimdenCikar(this.localValue.secilen_takipler, this.gorunurTakipler);
    else
      this.localValue.secilen_takipler = secimeEkle(this.localValue.secilen_takipler, this.gorunurTakipler);
    this.input();
  }

  success() {
    this.activeStep = 1;
    this.localValue.secilen_takipler = [];
    this.localValue.tabloFiltre = new TakipTabloFiltreEntity();
    this.$emit('onSuccess');
  }

  nextStep() {
    if (this.activeStep == 1) {
      this.getTakipler();
      this.activeStep++;
    } else if (this.activeStep == 2) {
      if (this.localValue.secilen_takipler.length == 0) this.takipSecilmediError = true;
      else this.activeStep++;
    } else if (this.activeStep < this.stepperHeaders.length) {
      this.activeStep++;
    }
    if (this.activeStep >= this.stepperHeaders.length) {
      this.$emit('final');
    }
    this.$emit('step', this.activeStep);
    this.focusStep(this.activeStep);
  }

  previousStep() {
    if (this.activeStep > 1) {
      this.activeStep--;
      this.uyapTakipLoadStatus = {
        loading: false,
        error: false,
        errorMessage: ''
      };
    }
    this.$emit('step', this.activeStep);
    this.focusStep(this.activeStep);
  }

  islemlereGit() {
    this.$router.push(ProgramPaths.eicrapro + '/islemler');
  }

  sifirla() {
    this.localValue = new GenelIslemEntity();
    this.input();
    this.activeStep = 1;
  }

  focusStep(step: any) {
    let activeHeader = (this.$refs['step' + step] as Vue[])[0].$el;
    let headers = this.$refs['headers'] as Element;
    let activeHeaderRight = activeHeader.getBoundingClientRect().right;
    let headersLeft = headers.getBoundingClientRect().left;
    let headersWidth = headers.getBoundingClientRect().width;
    let scrollPosition = (activeHeaderRight - headersLeft) - headersWidth;
    if (scrollPosition < 0) {
      scrollPosition = 0;
    }
    headers.scrollLeft += scrollPosition;
  }

}

export class GenelIslemEntity {
  /** 1. adim: UYAP sorgusunun parametreleri. Tabloyu filtrelemek icin KULLANILMAZ. */
  filtre: TakipFiltreEntity = new TakipFiltreEntity();
  excel!: File;
  takipler: Array<IAvukatDosya> = [];
  secilen_takipler: Array<IAvukatDosya> = [];
  /** 2. adim: yalnizca istemci tarafinda calisan tablo filtresi. (DEV-2718) */
  tabloFiltre: TakipTabloFiltreEntity = new TakipTabloFiltreEntity();
}

/**
 * DIKKAT: her alanin ACIK bir baslangic degeri olmali (`= undefined` dahil). Proje ts-loader +
 * TS 3.8.3 ile derleniyor (target ES2020, useDefineForClassFields kapali); initializer'i
 * olmayan class alani derlenmis ciktida hic olusmuyor, dolayisiyla Vue 2 Observer onu goremiyor
 * ve alan hicbir zaman reaktif olmuyor. dosyaYil / dosyaSira / dosyaSira2 tam olarak bu yuzden
 * ekrana yansimiyordu. (DEV-2721)
 */
export class TakipFiltreEntity {
  dosyaKapaliMi: 0 | 1 = 0;
  yargiTuru: number = 2;
  yargiBirimi: any = '1101';
  mahkeme: string = "";
  listeleme_turu: any = 1;
  dosyaYil: number | undefined = undefined;
  dosyaSira: number | undefined = undefined;
  dosyaSira2: number | undefined = undefined;
  baslangicTarihi: string = "";
  bitisTarihi: string = "";
  dosyaKapanisBaslangisTarihi: string = "";
  dosyaKapanisBitisTarihi: string = "";
  tcKimlikNo: string = '';
  adi: string = '';
  soyadi: string = '';
  kurumAdi: string = '';
  mersisNo: string = '';
  vergiNo: string = '';
}
